import { render, staticRenderFns } from "./PersonalReport2.vue?vue&type=template&id=16df1bf9&scoped=true&"
import script from "./PersonalReport2.vue?vue&type=script&lang=js&"
export * from "./PersonalReport2.vue?vue&type=script&lang=js&"
import style0 from "./PersonalReport2.vue?vue&type=style&index=0&id=16df1bf9&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16df1bf9",
  null
  
)

export default component.exports